module.exports = __webpack_public_path__ + "img/down.bc85b565.png";